export default __webpack_public_path__ + "static/media/globe.590d889b.svg";